export const REGION_LABELS = {
  ALL_REGIONS: 'All Regions',
  ALL_AGGREGATES: 'All Aggregates',
  ALL_CITIES: 'All Cities',
  ISO_REGIONS: 'ISO Regions',
  EIA_REGIONS: 'EIA Regions',
} as const;

export const AGG_LABELS = [
  REGION_LABELS.ISO_REGIONS,
  REGION_LABELS.EIA_REGIONS,
  REGION_LABELS.ALL_REGIONS,
] as const;
